import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getEmployees = (token) => async dispatch => {
    dispatch({
        type: actionTypes.GET_EMPLOYEES_START
    })
    const options = {
        url: `${api}/employees`,
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        data: {}
    }
    await axios(options)
        .then(response => dispatch({
            type: actionTypes.GET_EMPLOYEES_SUCCESS,
            payload: response.data
        }))
        .catch(error => dispatch({
            type: actionTypes.GET_EMPLOYEES_FAIL,
            payload: getMessage(error)
        }))
}